import { TemplateTag } from '../types';

/**
 * `forwarded` is true on both ends of a forward: the copy on the receiving gateway and the
 * source tag it was copied from. Source tags are regular tags and still need mapping.
 */
export const isForwardedInTag = (tag: TemplateTag) =>
  Boolean(tag.siteForwardedFrom || tag.gatewayForwardedFrom);
